import { isBefore, subMonths } from 'date-fns';
import { Bedomare } from '../models/bedomare.model';

const CONFIRMATION_THRESHOLD_MONTHS = 3;

export class BedomareHelper {
  static needsConfirmation(bedomare: Bedomare): boolean {
    const effectiveDate = BedomareHelper.getEffectiveConfirmationDate(bedomare);
    if (!effectiveDate) {
      return false;
    }

    return isBefore(
      effectiveDate,
      subMonths(new Date(), CONFIRMATION_THRESHOLD_MONTHS),
    );
  }

  // Fall tillbaka på senaste förordnande-accept om bedömaren aldrig bekräftat sin profil
  private static getEffectiveConfirmationDate(
    bedomare: Bedomare,
  ): Date | undefined {
    if (bedomare.senastBekraftad) {
      return bedomare.senastBekraftad;
    }

    const acceptDates = (bedomare.forordnanden ?? [])
      .map((forordnande) => forordnande.acceptDate)
      .filter((acceptDate): acceptDate is Date => !!acceptDate);

    if (acceptDates.length === 0) {
      return undefined;
    }

    return new Date(Math.max(...acceptDates.map((date) => date.getTime())));
  }
}
